// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

import styles from './FundColumns.module.scss';;


type Props = {
  children: Node,
  className?: string,
}

export const FundColumns = ({ children, className }: Props) => (
  <div className={classNames(styles.fundColumns, className)}>
    {children}
  </div>
);

export const Column = ({ children, className }: Props) => (
  <div className={classNames(styles.column, className)}>
    {children}
  </div>
);

export const Header = ({ children }: Props) => (
  <div className={styles.header}>
    {children}
  </div>
);

export const Content = ({ children }: Props) => (
  <div className={styles.content}>
    {children}
  </div>
);

export const Comment = ({ children }: Props) => (
  <div className={styles.comment}>
    {children}
  </div>
);
